import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import {HEADERS, TITLES} from './skuTypeConstants'
import cogoToast from "cogo-toast";
import { TOAST_MESSAGES } from "../../../utils/toastMsgConstant";
import { FEATURES } from "../../../utils/constant";

class ProductCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/service_category` })
      .then((dataArray) => {
        // console.log(dataArray.data.resultSet,'lloop');
        let data = isEmpty(dataArray) ? [] : dataArray.data?.resultSet?.map((element) => {
          if(element.isGstExempted === 1){
            element = {...element, isGstExempted: 'Yes'}
          } else if(element.isGstExempted === 0){
            element = {...element, isGstExempted: 'No'}
          }
          return element
        })
        this.setState({
          rowData: data,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_SKU_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    if(rowData.customerNumber === 0){
      cogoToast.error(TOAST_MESSAGES.CANNOT_EDIT_DEFAULT_RECORDS);
      return false
    }
    this.props.history.push("/edit-productType", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/productType");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: HEADERS.sku_type_code||"Product Category Code",
        field: "serviceCategoryCode",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.sku_type_name||"Product Category",
        field: "serviceCategory",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.is_gst_exempted||"Is GST Exempted",
        field: "isGstExempted",
        sortable: true,
        filter: true,
      }]
      
      if(FEATURES.isolationAndLoadTypeEnabledInProductCategory){
        Columns.push({
          headerName:HEADERS.product_isolation||"Isolation Category",
          field: "productIsolationData",
          sortable: true,
          filter: true,
        },
        {
          headerName:HEADERS.load_type||"Load Type",
          field: "loadTypeName",
          sortable: true,
          filter: true,
        })
      }
      
      Columns.push( 
      ...[{
        headerName: HEADERS.created_by||"Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: HEADERS.created_on||"Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: HEADERS.modified_by||"Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.modified_on||"Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName:HEADERS.actions||"Edit/Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_SKU_MASTER.UPDATE && !this.props.permissions.TA_SKU_MASTER.DELETE,
      },
    ])
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={TITLES.main_title||"Product Category"}
          titleBarLink={"/add-productType"}
          baseURL={"service_category"}
          pathName={"service_category"}
          keyIndex={"serviceCategoryId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_SKU_MASTER.UPDATE}
          hideRowDelete={false}
          hideFilter={true}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("skuType")(ProductCategory));
